/* eslint-disable no-restricted-imports */
import useResizeObserver from "use-resize-observer/polyfilled";

export default useResizeObserver;
